"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Represents a grid of application icons. Use this to render
 * `<AppSwitchItem>` components.
 *
 * Refer [AppSwitcher](#appswitcher) component for example and usage
 */


var AppSwitcherItems = function (_React$Component) {
  _inherits(AppSwitcherItems, _React$Component);

  function AppSwitcherItems() {
    _classCallCheck(this, AppSwitcherItems);

    return _possibleConstructorReturn(this, (AppSwitcherItems.__proto__ || Object.getPrototypeOf(AppSwitcherItems)).apply(this, arguments));
  }

  _createClass(AppSwitcherItems, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children;
      return _react2.default.createElement("div", {
        className: (0, _classnames2.default)("cdk-global-header__app-switcher-apps", className)
      }, _react2.default.createElement("ul", {
        className: "mdc-menu__items mdc-list cdk-global-header__app-switcher-apps-list",
        role: "menu",
        "aria-hidden": "true"
      }, children));
    }
  }]);

  return AppSwitcherItems;
}(_react2.default.Component);

exports.default = AppSwitcherItems;